import { useTranslation } from 'react-i18next';
import { Col, GroupLineIcon, Row, Text, useFormatMembersCount } from 'ui';

type P = { count: number };

const GiversCount = ({ count }: P) => {
  const { t } = useTranslation();
  const formattedParticipantsCount = useFormatMembersCount({ count });

  return (
    <Row gutter={['xxs', 0]}>
      <Col>
        <GroupLineIcon size="extra-small" />
      </Col>
      <Col>
        <Text>{t('formattedDonorsCount', { count, formattedCount: formattedParticipantsCount })}</Text>
      </Col>
    </Row>
  );
};

export default GiversCount;
